// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__2XgpV","contained":"OpenButton_contained__3wiaC","disabled":"OpenButton_disabled__2Ht6g","error":"OpenButton_error__2JNLt"};